export const environment = {
  "production": false,
  "recaptchaSiteKey": "6LfhwccsAAAAAHyt2GioTc6aF63HSu8cVBmaKQBF",
  "webapi": {
    "baseUrl": "https://prep-api.rejsebillet.dk/qrticketapi",
    "subscriptionKey": "7ed94432e82c42ecb4dbc2b8d7a6a253"
  },
  "lmsapi": {
    "baseUrl": "https://prep-api.rejsebillet.dk/api",
    "subscriptionKey": "094c8a263da94e84bcf8d4d14316b9d6"
  }
};
